/**
 * Starts loading the Material Icons font at startup, without waiting for it.
 * The browser only fetches a font once something on the page uses it, so
 * without this the first icons wait for the font to arrive.
 */
export function preloadIconFont(): void {
  if (typeof document === 'undefined' || !document.fonts) return;
  void document.fonts.load('24px "Material Icons"').catch(() => undefined);
}
